import React, { MouseEvent } from 'react';
import { Link } from '@grubhubprod/gh-cookbook-react';
import { useParams } from 'react-router-dom';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { getWindow } from 'src/utilities/window';
import { getHomePath } from 'src/constants/urls';

const ROUTE_CHANGE_ANALYTICS_DELAY = 500;

export function EnterpriseBackToHomeButton(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();

  const { sendTealiumEvent } = useAnalytics();
  const window = getWindow();

  function sendAnalytics(event: MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();

    const target = event.target as HTMLAnchorElement;

    sendTealiumEvent({
      eventcategory: 'corporate admin signup_all pages',
      eventaction: 'back to home_cta',
    });
    setTimeout(() => {
      window.location.href = target.href;
    }, ROUTE_CHANGE_ANALYTICS_DELAY);
  }

  if (corpid) {
    return (
      <Link href={getHomePath(corpid)} onClick={sendAnalytics}>
        Back to Home
      </Link>
    );
  }

  return null;
}
